var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectedItem.id)?_c('div',{staticClass:"pa-40 textAlignCenter"},[_c('AssetResume',{attrs:{"data":_vm.selectedItem,"type":"SP"}})],1):_c('div',{staticClass:"pa-40 textAlignCenter"},[(_vm.error)?_c('div',[_vm._v("\n\t\t\t"+_vm._s(_vm.error)+"\n\t\t")]):_c('div',[_vm._v("\n\t\t\tCargando...\n\t\t")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }